<template>
  <div
    :class="{
      'shadowed-product-container': shadowed,
    }"
  >
    <div
      :class="{
        'white-bg': !transparent,
      }"
    >
      <section v-for="(slot, index) in slots" :key="index">
        <slot :name="slot"></slot>
      </section>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Product',
    components: {},
    props: {
      slots: {
        required: true,
        default: [],
        type: Array,
      },
      shadowed: {
        required: true,
        default: false,
        type: Boolean,
      },
      transparent: {
        required: false,
        default: false,
        type: Boolean,
      },
      minHeight: {
        required: false,
        default: 0,
        type: Number,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .shadowed-product-container {
    box-shadow: 0px 24px 38px 0px #00000024;
  }

  .white-bg {
    background-color: #ffffff;
  }
</style>
